import { computeDiscountBonuses, type DiscountBonuses } from "../lib/discount-bonus.lib";
import { usePublicOrder } from "../queries/use-public-order";
import { usePublicShop } from "../queries/use-public-shop";
import { useDraftReturn } from "./use-draft-return";

/** Store-credit bonus for the whole draft, in cents. */
export function useDiscountBonuses(
  orderId: string,
  shopId: string,
): DiscountBonuses {
  const { data: order } = usePublicOrder(orderId);
  const { data: shop } = usePublicShop(shopId);
  const draft = useDraftReturn(orderId);

  return computeDiscountBonuses(shop, order, draft?.lineItems ?? []);
}
